import GenericDB from './generic-db'

export default class EcopledgeRecordsDB extends GenericDB {
  constructor(userId, ecopledgeId) {
    super(`users/${userId}/ecopledges/${ecopledgeId}/records`)
  }

  // Here you can extend UserEcopledgesDB with custom methods
}
